// extracted by mini-css-extract-plugin
export default {"favorite":"Favorite_favorite__UjXgt","favoriteIcon":"Favorite_favoriteIcon__Fo9bI"};